import styled from "styled-components";
import { Alert } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ContentCard } from "../../component/admin";
import CategoryDndEditor from "../../component/admin/categoryEditor/CategoryDndEditor";

const CategoryDndEditorPage = () => (
  <ContentCard title="카테고리 편집 (드래그앤드랍)">
    <InfoBox>
      <Alert
        message="드래그앤드랍 안내"
        description="각 행 왼쪽 핸들(⋮⋮)을 잡고 위아래로 드래그하면 순서가 바뀝니다. 항목을 왼쪽 '부모' 컬럼의 행 위로 드래그해서 놓으면 그 부모로 이동합니다. (게시글 → 서브/메인, 서브 → 메인, 메인 → 게시판)"
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        closable
      />
    </InfoBox>
    <CategoryDndEditor />
  </ContentCard>
);

const InfoBox = styled.div`
  margin-bottom: 16px;
`;

export default CategoryDndEditorPage;
